import React from 'react';

const EditLogsConsignments = (props) => {
    
    const handleRouteClick = (e) => {
        e.stopPropagation();
        // Prevent action if disabled
        if (!props.disabled) {
            props.onClickActive(props);
        }
    };

    return (
        <div className="map-icon-component" style={{ cursor: props.disabled ? "not-allowed" : "pointer" }}>
            {/* Conditionally render different icons based on iconType and disabled status */}
            {props.disabled ? (
               <img   
               src={require("../../assets/images/edit_logs_gray.png")} 
               style={{ height:"20px", color: "gray" }}
               alt="Edit Logs" 
               title='Edit Logs'
           />
             ) :  (
                
               
                <img 
                onClick={handleRouteClick}  
                src={require("../../assets/images/edit_logs_black.png")} 
                style={{ height:"20px", color: "black" }}
                alt="Edit Logs" 
                title='Edit Logs'
            />

        // ""
            ) }
        </div>
    );
};

export default EditLogsConsignments;
